import React from 'react';
import Secondaryctashort from './secondaryshort';
import Primaryctashort from './primaryshortcta';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import pic35 from '../../assets/pic35.png'
import { useLocation } from 'react-router-dom';




const Replay = ({ onCancel, replayRoute, currentLevel }) => {
    

         const [closing, setClosing] = useState(false);
        const location = useLocation();
         const navigate = useNavigate();

        const handleBack = () => {
            setClosing(true);
            setTimeout(() => onCancel(), 400);
        };

        const handleStart = () => {
            setClosing(true);

            setTimeout(() => {
                if (location.pathname.includes("level2")) {
                    navigate("/level2start");
                } else if (location.pathname.includes("level3")) {
                    navigate("/level3start");
                }  else if (location.pathname.includes("level4")) {
                    navigate("/level4start");
                }  else {
                    navigate("/level1start");
                }
            }, 400);
        };
            return (  <>
<main>
            <section className='levelbackground--page'>
           
 <>
       

               <section className='settings-background'>
            <section className={`mission-overlay ${closing ? 'slide-down' : 'slide-up'}`}>

                <section className='header-overlay'>
                    <div className='header-title-cont-settings'>
                        <h2 className='title-containerr-settings'>Replay?</h2>
                        <h2 className='title2-container-settings'>Replay?</h2>
                    </div>
                    
                        <button className='circlecta-cont' >
                         <div onClick={handleBack}>
                            <div className='circle-red'>
                                <img className='close-img' src={pic35} alt='close'></img>
                            </div>
                        </div>
                    </button>
                </section>


                <section className='container-mission'>
                    <section className='container-audio'>

                        <p className='para-mission'>Are you sure you want to replay the
                             level? Your current progress will restart.</p>

                    </section>
                </section>



                <div className='container-continue-how-to-play' >
                     <div onClick={handleStart}>
                    <Primaryctashort title='Replay' />
                    </div>
                    <div onClick={handleBack}>
                        <Secondaryctashort  title='Cancel'/>
                    </div>

                 
                </div>



                </section>
            </section>
        </>
              

               
            </section>
          </main>

         </> );
}
 
export default Replay;